import {Routes} from '@angular/router';
import {LayoutSelectorComponent} from './layouts/layout-selector/layout-selector.component';
import {AuthChildGuard, AuthGuard, UserPermissionGuard} from "@vision-inspection/authentification";
import {UserPermission} from "@vision-inspection/shared";

export const routes: Routes = [
  {
    path: '',
    component: LayoutSelectorComponent,
    data: {layout: 'default'},
    canActivate: [AuthGuard],
    canActivateChild: [AuthChildGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('@vision-inspection/ui-trainingspipeline').then(routes => routes.UI_TRAININGPIPELINE_ROUTES), // eslint-disable-line
      },
      {
        path: 'legalNotice',
        loadChildren: () =>
          import('./_pages/legal-notice/legal-notice.routes').then((m) => m.LEGAL_NOTICE_ROUTES), // eslint-disable-line
      },
      {
        path: 'administration',
        children: [
          {
            path: 'camera-configuration',
            loadChildren: () =>
              import('@vision-inspection/ui-administration-camera-configuration').then((routes) => routes.UI_ADMINISTRATION_CAMERA_CONFIGURATION_ROUTES), // eslint-disable-line
          },
          {
            path: 'tenants',
            canActivate: [UserPermissionGuard],
            data: {userPermission: [UserPermission.ViewPageTenants]},
            loadChildren: () => import('@vision-inspection/ui-administration-tenant').then(routes => routes.UI_ADMINISTRATION_ROUTES), // eslint-disable-line
          }
        ]
      },
    ],
  },
  {
    path: 'error',
    component: LayoutSelectorComponent,
    data: {
      layout: 'default',
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./_pages/error/error.routes').then((m) => m.ERROR_ROUTES),
      },
    ],
  },
];
